import { Component } from 'react';
import classNames from 'classnames';

import Cell from '../Cell';
import { IconCollapse } from '../../ui/IconCollapse';
import { IconExpand } from '../../ui/IconExpand';
import PropertyRow from '../../PropertyRow';
import DevCategoryPriority from '../../DevCategoryPriority';
import { getProductsWithCategory } from '../../../utils';
import { WIDTH_COLUMN_CATEGORY } from '../../../config/consts';
import styles from '../index.module.scss';
import { ProductsParametersApi } from '@pes-ui/utils/lib/types/api/products-parameters-api';
import { MappedProduct } from '../../../utils/mappers';
import RunTimeWidget from '../RunTimeWidget';
import { ComparatorRuntimeInfo } from '@pes-ui/utils/lib/types/comparator';

type Props = {
    category: ProductsParametersApi.Section;
    products: MappedProduct[];
    currentStateKey: string; //ProductsParametersApi.Section['priority'] + '_' + ProductsParametersApi.Section['name'];
    toggleSectionHandler: (currentStateKey) => void;
    toggleState: Record<string, boolean>[string]; //ProductsParametersApi.Section['priority'] + '_' + ProductsParametersApi.Section['name'];
    showDevPrioritiesInfo: boolean;
    isKeyCategory: ProductsParametersApi.Section['keySection'];
    topContainerWidth?: number;
    hideSimilarFeatures: boolean;
    highlightDifferences: boolean;
    isHorizontalScroll?: boolean;
    runtimeInfo?: ComparatorRuntimeInfo;
    linkClickHandlerCallback?: (link: string) => void;
};

export class DesktopCompareResults extends Component<Props> {
    static defaultProps = {
        showDevPrioritiesInfo: false,
        toggleState: false,
        isKeyCategory: false,
        isHorizontalScroll: false
    };

    handleToggleClick = () => {
        const { currentStateKey, toggleSectionHandler } = this.props;

        toggleSectionHandler(currentStateKey);
    };

    getAvailableProductsID = (products: MappedProduct[]): string[] => {
        return products.map(product => product.productId);
    }

    renderCategoryBody() {
        const { category, products, highlightDifferences, isHorizontalScroll, linkClickHandlerCallback } = this.props;
        const categoryValues = Object.keys(category.parameters);

        return categoryValues.map((value, index) => {
            const productsWithCategory = getProductsWithCategory(products, value);
            const isHidableRow = category.parameters[value].hidable;
            const isComparable = category.parameters[value].comparable;

            if (!productsWithCategory.length) {
                return null;
            }

            return this.props.hideSimilarFeatures && isHidableRow && isComparable ? null : (
                <PropertyRow
                    key={`${value}-${index}`}
                    products={products}
                    category={category}
                    value={value}
                    highlightDifferences={highlightDifferences && isComparable}
                    isRowHighlighted={!isHidableRow}
                    isHorizontalScroll={isHorizontalScroll}
                    linkClickHandlerCallback={linkClickHandlerCallback}
                />
            );
        });
    }
    render() {
        const { category, products, toggleState, isHorizontalScroll, runtimeInfo, hideSimilarFeatures } = this.props;

        const categoryParameters = Object.keys(category.parameters);

        const isSectionHidable = categoryParameters.every(item => {
            const isAllHidableRow = category.parameters[item].hidable;

            return isAllHidableRow;
        });

        const rowClasses = classNames(
            'row',
            'flex-row',
            'flex-nowrap',
            'no-gutters',
            [styles.group],
            'analytics-compare-toggle',
        );

        const widthForCategoryName = products.length <= 4 ?
            'auto' :
            `${(products.length + 1) * WIDTH_COLUMN_CATEGORY - 2}px`;

        return (
            <div
                data-item-expanded={toggleState} 
                data-category-name={category.tag} 
                style={{width: widthForCategoryName}}
                className={classNames(
                    {[styles.categoryHeader_collapsed]: hideSimilarFeatures && isSectionHidable}
                )}
            >
                {/* Category title */}
                {hideSimilarFeatures && isSectionHidable && category.name !== runtimeInfo?.mainSectionName ? null : (
                    <div 
                        className={rowClasses}
                        onClick={this.handleToggleClick}
                    >
                        <Cell 
                            labelCol
                            isHorizontalScroll={isHorizontalScroll}
                        >
                            <div
                                className={styles.groupTitle}
                            >
                                <h2 className={styles.categoryTitle}>
                                    {category.name.replace('amp;', '')}
                                </h2>
                                <div className={styles.compareToggleBtn}>
                                    {toggleState ? (
                                        <IconExpand className={styles.groupTitleToggleIcon} />
                                    ) : (
                                        <IconCollapse className={styles.groupTitleToggleIcon} />
                                    )}
                                </div>
                                {this.props.showDevPrioritiesInfo ? (
                                    <DevCategoryPriority priority={category.priority} />
                                ) : null}
                            </div>
                        </Cell>
                        {products.map((prod, i) => <Cell key={`${prod.productId}-${i}`} />)}
                    </div>
                )}
                {/* Category body */}
                {category.name === runtimeInfo?.mainSectionName ? 
                    <RunTimeWidget
                        isHorizontalScroll={isHorizontalScroll}
                        runtimeInfo={runtimeInfo}
                        productsId={this.getAvailableProductsID(products)}
                        toggleState={!toggleState}
                    />
                    :
                    null
                }
                {toggleState ? null : this.renderCategoryBody()}
            </div>
        );
    }
}
